import { useMemo } from 'react';
import { ADDITION_MARK_TO_CATEGORY, PlanCategoryEnum } from '@/config';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppSelector } from '@/redux/hooks';
import { profileSelectors } from '@/redux/selectors';
import { getFormattedDate } from '@/helpers';
import { SectionBox } from '@/components/SectionBox';
import { TariffBadge } from '@/components/TariffBadge';
import { TariffsSummaryItem } from '../TariffsSummaryItem/TariffsSummaryItem';

import styles from './TariffsSummary.module.sass';

interface TariffsSummaryProps {}

export const TariffsSummary = (props: TariffsSummaryProps) => {
  const { t } = useTranslation();
  const { data: profileData } = useAppSelector(
    profileSelectors.getProfileSlice,
  );

  const totalChecks = 100;
  const usedChecks = 75;

  const expireBarWidth = (usedChecks / totalChecks) * 100;

  const badgeType = useMemo(() => {
    if (profileData?.currentPlan) {
      return ADDITION_MARK_TO_CATEGORY[profileData.currentPlan.plan_addition];
    }
    return PlanCategoryEnum.LITE;
  }, [profileData]);

  return (
    <SectionBox size="medium-new">
      {{
        title: t('translation.subscription_subtitle'),
        className: styles.section,
        body: (
          <>
            <div className={styles.summary}>
              <TariffsSummaryItem label={t('translation.current_plan')}>
                <div className={styles.currentPlan}>
                  <span>
                    {profileData?.currentPlan
                      ? profileData.currentPlan.plan_name
                      : ''}
                  </span>
                  <TariffBadge tariff={badgeType} />
                </div>
              </TariffsSummaryItem>

              {/* <TariffsSummaryItem label={t('translation.expires_label')}>
                <span className={styles.expire}>
                  {usedChecks} / {totalChecks}
                </span>
                <div className={styles.usedLevel}>
                  <div
                    className={styles.usedLevelBar}
                    style={{ width: `${expireBarWidth}%` }}
                  />
                </div>
              </TariffsSummaryItem> */}

              <TariffsSummaryItem
                label={t('translation.package_expires_label')}
              >
                {profileData?.currentPlan
                  ? getFormattedDate(profileData.currentPlan.expires_on)
                  : ''}
              </TariffsSummaryItem>

              <TariffsSummaryItem
                label={t('translation.current_package_label')}
              >
                {profileData?.currentPlan
                  ? `$${profileData.currentPlan.plan_price}`
                  : ''}
              </TariffsSummaryItem>

              <TariffsSummaryItem label={t('translation.cost_per_check_label')}>
                {profileData?.currentPlan
                  ? `$${(
                      profileData.currentPlan.plan_price /
                      profileData.currentPlan.check_number
                    ).toFixed(2)}`
                  : ''}
              </TariffsSummaryItem>
            </div>

            {/* <div className={styles.moreChecks}>
              {t('translation.ask_need_checks')}{' '}
              <Link to="/" className={styles.link}>
                {t('translation.check_out_pro_plans')}
              </Link>
            </div> */}
          </>
        ),
      }}
    </SectionBox>
  );
};
